import React from 'react';
import '../../boom/boom.css';

interface BoomJuniorShellProps {
  children: React.ReactNode;
  className?: string;
}

/** Contenedor que aplica estilos Boom dentro del shell de Junior. */
export function BoomJuniorShell({ children, className = '' }: BoomJuniorShellProps) {
  return <div className={`boom-junior ${className}`.trim()}>{children}</div>;
}
